/* Fleet1st — shared behaviour for every f1-* section.
   Loaded once (the browser de-duplicates the file), safe to include from several sections. */
(function () {
  if (window.__f1Shared) return;
  window.__f1Shared = true;

  /* Show a labelled placeholder when an image file is missing */
  document.addEventListener('error', function (e) {
    var t = e.target;
    if (t && t.tagName === 'IMG') { var h = t.closest('.f1-media,.f1-logo'); if (h) h.classList.add('is-broken'); }
  }, true);

  function markBroken() {
    document.querySelectorAll('.f1 img').forEach(function (img) {
      if (img.complete && img.naturalWidth === 0) { var h = img.closest('.f1-media,.f1-logo'); if (h) h.classList.add('is-broken'); }
    });
  }

  /* Lite video embeds: load YouTube/Vimeo only when the visitor presses play */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-f1-embed]');
    if (!b) return;
    var box = b.closest('.f1-media'), f = document.createElement('iframe');
    f.src = b.dataset.f1Embed;
    f.allow = 'autoplay; encrypted-media; picture-in-picture';
    f.allowFullscreen = true;
    f.title = b.getAttribute('aria-label') || 'Video';
    box.innerHTML = '';
    box.appendChild(f);
  });

  /* "On this page" bar: highlight the section in view */
  function initNav() {
    var nav = document.querySelector('[data-f1-secnav]');
    if (!nav || nav.dataset.ready || !('IntersectionObserver' in window)) return;
    nav.dataset.ready = '1';
    var links = Array.prototype.slice.call(nav.querySelectorAll('a[href^="#"]:not(.f1-navcta)'));
    var io = new IntersectionObserver(function (ents) {
      ents.forEach(function (en) {
        if (en.isIntersecting) links.forEach(function (a) { a.classList.toggle('is-on', a.getAttribute('href') === '#' + en.target.id); });
      });
    }, { rootMargin: '-40% 0px -55% 0px' });
    links.forEach(function (a) {
      var s = document.getElementById(a.getAttribute('href').slice(1));
      if (s) io.observe(s);
    });
  }

  function boot() { markBroken(); initNav(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
